import {
  Button,
  Grid,
  InputAdornment,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  ListItemIcon,
} from '@material-ui/core';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { LoadingButton } from '@mui/lab';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Box } from '@mui/system';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadGridUser } from '../../helpers/loadGrid';
import { startUpdateUser, validarAEATUser } from '../../redux/actions/users';
import { useFormStyles } from '../../styles/formStyles';
import { validationSchemaUserEdit } from '../../utils/schemaValidationForm';
import { FormikDatePicker } from '../ui/FormikDatePicker';
import esLocale from 'date-fns/locale/es';
import { AccountCircleRounded, ApartmentOutlined, Euro, InsertLinkOutlined } from '@material-ui/icons';
import { navigate } from '@reach/router';
import { ROLREVENDEDOR } from '../../utils/constants';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { SwitchMUI } from '../ui/Switch';
import { loadCurrencies } from '../../helpers/loadCurrencies';
import { CustomizedSelect } from '../../components/ui/CustomizedSelect';
import { getCountries } from '@/redux/actions/countryService';
import { useAppSelector } from '@/hooks/useAppSelector';
import { StandardAutocomplete } from '@/components/ui/StandardAutocomplete';
import { ForceOtroDocumentoProbatorioEffect } from '@/helpers/formik-effects/forceOtroDocumentoProbatorioEffect';
import { shouldForceOtroDocumentoProbatorio } from '@/utils/nemonIntegration';
import { syncNemonUser } from '@/redux/actions/users';
import SyncIcon from '@mui/icons-material/Sync';

const alwaysRequired = ['name', 'email', 'password', 'telefono']; // campos siempre obligatorios
const revendedorRequired = ['NIF', 'Direccion', 'FkPaises', 'CodigoPostal', 'Municipio', 'Provincia']; // campos adicionales para revendedor

const isFieldRequired = (fieldName, rol, esEmpresa, esAgencia) => {
  if (alwaysRequired.includes(fieldName)) return true;
  if (rol === ROLREVENDEDOR && revendedorRequired.includes(fieldName)) return true;
  if (fieldName === 'surname' && rol === ROLREVENDEDOR && !(esEmpresa)) return true;
  if (fieldName === 'razonSocial' && rol === ROLREVENDEDOR && esEmpresa) return true;
  if (fieldName === 'nombrePersonaFisica' && rol === ROLREVENDEDOR && esEmpresa === false && esAgencia) return true;
  return false;
};

export const UserInfo = () => {
  const classes = useFormStyles();

  const dispatch = useDispatch();
  const { active } = useSelector(state => state.user);
  const { data } = loadGridUser(active?.EsAgencia);
  const result = data.filter(e => e?.type !== 'detail' && e?.filter === undefined && e?.filterdetail === undefined);
  const currencies = loadCurrencies();

  const { countries } = useAppSelector(state => state.country);

  const [isLoadingSync, setIsLoadingSync] = useState(false);
  const [isLoadingValidarAEAT, setIsLoadingValidarAEAT] = useState(false);

  const countryOptions = countries.map(country => ({
    label: country.Nombre,
    value: country.PkPaises,
  }));

  useEffect(() => {
    dispatch(getCountries());
  }, [dispatch]);

  const handleValidarAEAT = () => {
    dispatch(validarAEATUser(active?.PkUsuarios, setIsLoadingValidarAEAT));
  };

  const handleSyncNemon = () => {
    dispatch(syncNemonUser(active?.PkUsuarios, setIsLoadingSync));
  };

  const handleSubmit = (values, { setSubmitting }) => {
    const user = {
      PkUsuarios: active?.PkUsuarios,
      Email: values.email,
      Nombre: values.name,
      Apellidos: values.surname,
      Telefono: values.telefono,
      Telefono2: values.Telefono2 || '',
      Observaciones: values.observaciones ? values.observaciones : '',
      FechaBaja: !values.date ? null : values.date,
      VersionFila: active?.VersionFila,
      RazonSocial: values.razonSocial ?? '',
      UrlB2B: values.UrlB2B ?? '',
      NIF: values.NIF ?? '',
      TextoPiePresupuesto: values.TextoPiePresupuesto || '',
      TextoTransferencias: values.TextoTransferencias || '',
      ImporteComision: +values.ImporteComision,
      ImporteComisionDescuento: +values.ImporteComisionDescuento,
      PorcentajeComision: +values.PorcentajeComision,
      ComisionaPorImporte: values.ComisionaPorImporte ?? false,
      Comisiona: values.Comisiona ?? false,
      Moneda: values.Moneda,
      MargenConfiguradoEnServicios: values.MargenConfiguradoEnServicios,
      CodigoLicencia: values.CodigoLicencia || '',
      Direccion: values.Direccion,
      Numero: values.Numero,
      Piso: values.Piso,
      DireccionComplementaria: values.DireccionComplementaria,
      CodigoPostal: values.CodigoPostal,
      Municipio: values.Municipio,
      Provincia: values.Provincia,
      FkPaises: values.FkPaises ?? -1,
      OtroDocumentoProbatorio: values.OtroDocumentoProbatorio,
      EsAgencia: active?.EsAgencia ?? false,
      EsEmpresa: values.EsEmpresa ?? false,
      NombrePersonaFisica:
        active?.Rol?.PkRoles === ROLREVENDEDOR && active?.EsAgencia
          ? (values.nombrePersonaFisica ?? '')
          : '',
    };
    dispatch(startUpdateUser(user, setSubmitting));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={esLocale}>
      <Formik
        validationSchema={validationSchemaUserEdit(active?.Rol?.PkRoles === ROLREVENDEDOR, active?.EsAgencia)}
        enableReinitialize={true}
        initialValues={{
          CodigoLicencia: active?.CodigoLicencia || '',
          name: active?.Nombre,
          surname: active?.Apellidos,
          observaciones: active?.Observaciones,
          telefono: active?.Telefono || '',
          Telefono2: active?.Telefono2 || '',
          email: active?.Email,
          date: active?.FechaBaja,
          razonSocial: active?.RazonSocial,
          UrlB2B: active?.UrlB2B || '',
          NIF: active?.NIF,
          TextoPiePresupuesto: active?.TextoPiePresupuesto || '',
          TextoTransferencias: active?.TextoTransferencias || '',
          ImporteComision: active?.ImporteComision ?? 0,
          ImporteComisionDescuento: active?.ImporteComisionDescuento ?? 0,
          PorcentajeComision: active?.PorcentajeComision ?? 0,
          Comisiona: active?.Comisiona ?? false,
          ComisionaPorImporte: active?.ComisionaPorImporte ?? false,
          Moneda: active?.Moneda,
          MargenConfiguradoEnServicios: active?.MargenConfiguradoEnServicios,
          Direccion: active?.Direccion,
          Numero: active?.Numero,
          Piso: active?.Piso,
          DireccionComplementaria: active?.DireccionComplementaria,
          CodigoPostal: active?.CodigoPostal,
          Municipio: active?.Municipio,
          Provincia: active?.Provincia,
          FkPaises: active?.FkPaises,
          OtroDocumentoProbatorio: Boolean(active?.OtroDocumentoProbatorio),
          IdNemon: active?.IdNemon,
          EsEmpresa: active?.EsEmpresa,
          nombrePersonaFisica: active?.NombrePersonaFisica || '',
        }}
        onSubmit={handleSubmit}>
        {({ handleChange, errors, values, handleBlur, isSubmitting, touched, isValid, setFieldValue }) => {
          const selectedCountry = countries.find(c => c.PkPaises === values.FkPaises);

          const forceOtroDocumentoProbatorio = selectedCountry
            ? shouldForceOtroDocumentoProbatorio(
                selectedCountry.Codigo,
                selectedCountry?.EsIntracomunitario,
                values.EsEmpresa,
              )
            : false;

          return (
            <Grid md={6} xs={11}>
              <Form>
                <ForceOtroDocumentoProbatorioEffect countries={countries} />
                <Box sx={{ p: 2, mb: 4 }}>
                  <Typography variant="h1">Usuario {active?.Rol?.Nombre}</Typography>
                </Box>
                {active?.EsAgencia && (
                  <Box sx={{ mb: 2 }}>
                    <SwitchMUI
                      label="Es empresa"
                      name="EsEmpresa"
                      values={values}
                      setFieldValue={setFieldValue}
                      disabled={isSubmitting || !(active?.Rol?.PkRoles === ROLREVENDEDOR && !active?.IdNemon)}
                    />
                  </Box>
                )}
                <Grid container spacing={3}>
                  {result.map(element => {
                    const esAgenciaRevendedor =
                      active?.Rol?.PkRoles === ROLREVENDEDOR && active?.EsAgencia;

                    if (element.name === 'surname' && esAgenciaRevendedor) {
                      return (
                        <React.Fragment key="nombrePersonaFisica-surname-group">
                          <Grid key="nombrePersonaFisica" item md={6} xs={12}>
                            <TextField
                              fullWidth
                              name="nombrePersonaFisica"
                              size="small"
                              classes={{ root: classes.inputText }}
                              id="outlined-basic-nombrePersonaFisica"
                              label="Nombre"
                              variant="outlined"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <AccountCircleRounded />
                                  </InputAdornment>
                                ),
                                classes: { input: classes.resize },
                              }}
                              InputLabelProps={{ style: { fontSize: '0.8em' } }}
                              value={values.nombrePersonaFisica}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              error={touched.nombrePersonaFisica && Boolean(errors.nombrePersonaFisica)}
                              helperText={touched.nombrePersonaFisica && errors.nombrePersonaFisica}
                              disabled={isSubmitting}
                              required={isFieldRequired(
                                'nombrePersonaFisica',
                                active?.Rol?.PkRoles,
                                values.EsEmpresa,
                                active?.EsAgencia,
                              )}
                            />
                          </Grid>
                          <Grid key="surname" item md={6} xs={12}>
                            <TextField
                              fullWidth
                              name="surname"
                              size="small"
                              classes={{ root: classes.inputText }}
                              id="outlined-basic-surname"
                              label="Apellidos"
                              variant="outlined"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <AccountCircleRounded />
                                  </InputAdornment>
                                ),
                                classes: { input: classes.resize },
                              }}
                              InputLabelProps={{ style: { fontSize: '0.8em' } }}
                              value={values.surname}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              error={touched.surname && Boolean(errors.surname)}
                              helperText={touched.surname && errors.surname}
                              disabled={isSubmitting}
                              required={isFieldRequired(
                                'surname',
                                active?.Rol?.PkRoles,
                                values.EsEmpresa,
                                active?.EsAgencia,
                              )}
                            />
                          </Grid>
                        </React.Fragment>
                      );
                    }

                    if (element.name === 'FkPaises') {
                      return (
                        <Grid key={element.name} item md={6} xs={12}>
                          <StandardAutocomplete
                            name={element.name}
                            label={'País'}
                            value={values.FkPaises}
                            onChange={val => setFieldValue('FkPaises', Number(val))}
                            options={countryOptions}
                            required={isFieldRequired(
                              element.name,
                              active?.Rol?.PkRoles,
                              values.EsEmpresa,
                              active?.EsAgencia,
                            )}
                            error={touched.FkPaises && Boolean(errors.FkPaises)}
                            helperText={touched.FkPaises && errors.FkPaises}
                          />
                        </Grid>
                      );
                    }

                    return (
                      <Grid key={element.name} item md={6} xs={12}>
                        <TextField
                          fullWidth
                          name={element.name}
                          size="small"
                          classes={{ root: classes.inputText }}
                          id={`outlined-basic-${element.name}`}
                          label={
                            element.name === 'name' && esAgenciaRevendedor
                              ? 'Nombre comercial'
                              : element.label
                          }
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">{element.startAdornment}</InputAdornment>
                            ),
                            classes: {
                              input: classes.resize,
                            },
                          }}
                          InputLabelProps={{ style: { fontSize: '0.8em' } }}
                          value={values[element.name]}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={touched[element.name] && Boolean(errors[element.name])}
                          helperText={touched[element.name] && errors[element.name]}
                          disabled={isSubmitting}
                          multiline={element.name === 'observaciones' ? true : false}
                          maxRows={element.name === 'observaciones' ? 10 : undefined}
                          minRows={element.name === 'observaciones' ? 5 : undefined}
                          required={isFieldRequired(
                            element.name,
                            active?.Rol?.PkRoles,
                            values.EsEmpresa,
                            active?.EsAgencia,
                          )}
                        />
                      </Grid>
                    );
                  })}

                  <Grid item md={6} xs={12}>
                    <Field
                      style={{ fontSize: '0.8em' }}
                      component={FormikDatePicker}
                      label="Fecha Baja"
                      textfield="date"
                      name="date"
                      isSubmitting={isSubmitting}
                      value={active?.FechaBaja}
                    />
                  </Grid>

                  <Grid item md={6} xs={12} classes={{ root: classes.container }}>
                    <Box>
                      <FormControl
                        fullWidth
                        style={{
                          marginTop: '1rem',
                        }}
                        disabled={isSubmitting}
                        onBlur={handleBlur}
                        onChange={handleChange}>
                        <InputLabel style={{ fontSize: '1rem' }} id="select-label-exchange-rates">
                          Moneda
                        </InputLabel>
                        <Field name="Moneda" component={CustomizedSelect}>
                          {currencies.map(c => {
                            return (
                              <MenuItem style={{ fontSize: '0.7em' }} value={c.code}>
                                <ListItemIcon>{c.icon()}</ListItemIcon>
                                {c.label}
                              </MenuItem>
                            );
                          })}
                        </Field>
                      </FormControl>
                    </Box>
                  </Grid>

                  {active?.EsAgencia && (
                    <>
                      <Grid item md={6} xs={12}>
                        <TextField
                          fullWidth
                          name="Telefono2"
                          size="small"
                          classes={{ root: classes.inputText }}
                          id={`outlined-basic-Telefono2`}
                          label="Teléfono 2"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <ApartmentOutlined />
                              </InputAdornment>
                            ),
                            classes: {
                              input: classes.resize,
                            },
                          }}
                          InputLabelProps={{ style: { fontSize: '0.8em' } }}
                          value={values.Telefono2}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={touched.Telefono2 && Boolean(errors.Telefono2)}
                          helperText={touched.Telefono2 && errors.Telefono2}
                          disabled={isSubmitting}
                        />
                      </Grid>

                      {values.EsEmpresa && (
                        <Grid item md={6} xs={12}>
                          <TextField
                            fullWidth
                            name="razonSocial"
                            size="small"
                            classes={{ root: classes.inputText }}
                            id={`outlined-basic-razonSocial`}
                            label="Razón Social"
                            required={isFieldRequired(
                              'razonSocial',
                              active?.Rol?.PkRoles,
                              values.EsEmpresa,
                              active?.EsAgencia,
                            )}
                            variant="outlined"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <ApartmentOutlined />
                                </InputAdornment>
                              ),
                              classes: {
                                input: classes.resize,
                              },
                            }}
                            InputLabelProps={{ style: { fontSize: '0.8em' } }}
                            value={values.razonSocial}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={touched.razonSocial && Boolean(errors.razonSocial)}
                            helperText={touched.razonSocial && errors.razonSocial}
                            disabled={isSubmitting}
                          />
                        </Grid>
                      )}

                      <Grid item md={6} xs={12}>
                        <TextField
                          fullWidth
                          name="CodigoLicencia"
                          size="small"
                          classes={{ root: classes.inputText }}
                          id={`outlined-basic-razonSocial`}
                          label="Código de licencia"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <ApartmentOutlined />
                              </InputAdornment>
                            ),
                            classes: {
                              input: classes.resize,
                            },
                          }}
                          InputLabelProps={{ style: { fontSize: '0.8em' } }}
                          value={values.CodigoLicencia}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={touched.CodigoLicencia && Boolean(errors.CodigoLicencia)}
                          helperText={touched.CodigoLicencia && errors.CodigoLicencia}
                          disabled={isSubmitting}
                        />
                      </Grid>

                      {active?.Rol.PkRoles === ROLREVENDEDOR && (
                        <>
                          <Grid item md={12} xs={12}>
                            <SwitchMUI
                              label={(() => {
                                const selectedCountry = countries.find(c => c.PkPaises === values.FkPaises);
                                return selectedCountry?.Codigo?.toLowerCase() === 'es'
                                  ? 'No censado'
                                  : 'Otro documento probatorio';
                              })()}
                              name="OtroDocumentoProbatorio"
                              values={values}
                              setFieldValue={setFieldValue}
                              style={undefined}
                              disabled={forceOtroDocumentoProbatorio}
                            />
                          </Grid>
                          <Grid item md={12} xs={12}>
                            <TextField
                              fullWidth
                              name="NIF"
                              size="small"
                              classes={{ root: classes.inputText }}
                              id={`outlined-basic-NIF`}
                              label={(() => {
                                const selectedCountry = countries.find(c => c.PkPaises === values.FkPaises);
                                if (values.OtroDocumentoProbatorio) return 'ID';

                                if (values.EsEmpresa) {
                                  if (selectedCountry?.Codigo?.toLowerCase() === 'es') return 'CIF';
                                  if (selectedCountry?.EsIntracomunitario) return 'VAT Number';
                                  return 'ID';
                                }

                                return selectedCountry?.Codigo?.toLowerCase() === 'es' ? 'NIF' : 'ID';
                              })()}
                              variant="outlined"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <ApartmentOutlined />
                                  </InputAdornment>
                                ),
                                classes: {
                                  input: classes.resize,
                                },
                              }}
                              InputLabelProps={{ style: { fontSize: '0.8em' } }}
                              value={values.NIF}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              error={touched.NIF && Boolean(errors.NIF)}
                              helperText={touched.NIF && errors.NIF}
                              disabled={isSubmitting}
                            />
                          </Grid>
                          {!active.FkUsuarios_Agencia && (
                            <>
                              <Grid item md={12} xs={12}>
                                <TextField
                                  fullWidth
                                  name="IdNemon"
                                  size="small"
                                  classes={{ root: classes.inputText }}
                                  id={`outlined-basic-IdNemon`}
                                  label="Id Nemon"
                                  variant="outlined"
                                  InputProps={{
                                    classes: {
                                      input: classes.resize,
                                    },
                                  }}
                                  InputLabelProps={{ style: { fontSize: '0.8em' } }}
                                  value={values.IdNemon ? values.IdNemon : 'Usuario no sincronizado con Nemon'}
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  error={touched.IdNemon && Boolean(errors.IdNemon)}
                                  helperText={touched.IdNemon && errors.IdNemon}
                                  disabled={true}
                                />
                              </Grid>
                              <Grid item md={12} xs={12}>
                                <Box display={'flex'} flexDirection="row" gap={4}>
                                  <LoadingButton
                                    variant="contained"
                                    type="button"
                                    loading={isSubmitting || isLoadingValidarAEAT}
                                    disabled={!isValid || active?.OtroDocumentoProbatorio}
                                    style={{
                                      backgroundColor: '#E5824F',
                                    }}
                                    onClick={handleValidarAEAT}>
                                    Validar con AEAT
                                  </LoadingButton>
                                  <LoadingButton
                                    variant="contained"
                                    type="button"
                                    loading={isSubmitting || isLoadingSync}
                                    disabled={!isValid}
                                    style={{
                                      backgroundColor: '#E5824F',
                                    }}
                                    startIcon={<SyncIcon />}
                                    onClick={handleSyncNemon}>
                                    Sincronizar
                                  </LoadingButton>
                                </Box>
                              </Grid>
                            </>
                          )}
                        </>
                      )}

                      <Grid item md={12} xs={12}>
                        <TextField
                          fullWidth
                          name="UrlB2B"
                          size="small"
                          classes={{ root: classes.inputText }}
                          id={`outlined-basic-razonSocial`}
                          label="Link acceso B2B"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <InsertLinkOutlined />
                              </InputAdornment>
                            ),
                            classes: {
                              input: classes.resize,
                            },
                          }}
                          InputLabelProps={{ style: { fontSize: '0.8em' } }}
                          value={values.UrlB2B}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={touched.UrlB2B && Boolean(errors.UrlB2B)}
                          helperText={touched.UrlB2B && errors.UrlB2B}
                          disabled={isSubmitting}
                        />
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <SwitchMUI
                          label="Margen Configurado en servicios"
                          name="MargenConfiguradoEnServicios"
                          values={values}
                          setFieldValue={setFieldValue}
                        />
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <SwitchMUI label="Comisiona" name="Comisiona" values={values} setFieldValue={setFieldValue} />
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <SwitchMUI
                          label="Comisiona por importe"
                          name="ComisionaPorImporte"
                          values={values}
                          setFieldValue={setFieldValue}
                          disabled={isSubmitting || values?.Comisiona === false}
                        />
                      </Grid>

                      <Grid key="ImporteComision" item md={4} xs={12}>
                        <TextField
                          fullWidth
                          name="ImporteComision"
                          size="small"
                          classes={{ root: classes.inputText }}
                          id={`outlined-basic-ImporteComision`}
                          label={'Importe Comisión'}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Euro />
                              </InputAdornment>
                            ),
                            classes: {
                              input: classes.resize,
                            },
                          }}
                          InputLabelProps={{ style: { fontSize: '0.8em' } }}
                          value={values['ImporteComision']}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={touched['ImporteComision'] && Boolean(errors['ImporteComision'])}
                          helperText={touched['ImporteComision'] && errors['ImporteComision']}
                          disabled={
                            isSubmitting || values?.Comisiona === false || values?.ComisionaPorImporte === false
                          }
                        />
                      </Grid>

                      <Grid key="ImporteComisionDescuento" item md={4} xs={12}>
                        <TextField
                          fullWidth
                          name="ImporteComisionDescuento"
                          size="small"
                          classes={{ root: classes.inputText }}
                          id={`outlined-basic-ImporteComisionDescuento`}
                          label={'Importe Comisión con descuento'}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Euro />
                              </InputAdornment>
                            ),
                            classes: {
                              input: classes.resize,
                            },
                          }}
                          InputLabelProps={{ style: { fontSize: '0.8em' } }}
                          value={values['ImporteComisionDescuento']}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={touched['ImporteComisionDescuento'] && Boolean(errors['ImporteComisionDescuento'])}
                          helperText={touched['ImporteComisionDescuento'] && errors['ImporteComisionDescuento']}
                          disabled={
                            isSubmitting || values?.Comisiona === false || values?.ComisionaPorImporte === false
                          }
                        />
                      </Grid>

                      <Grid key="PorcentajeComision" item md={4} xs={12}>
                        <TextField
                          fullWidth
                          name="PorcentajeComision"
                          size="small"
                          classes={{ root: classes.inputText }}
                          id={`outlined-basic-PorcentajeComision`}
                          label={'% Comisión'}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Euro />
                              </InputAdornment>
                            ),
                            classes: {
                              input: classes.resize,
                            },
                          }}
                          InputLabelProps={{ style: { fontSize: '0.8em' } }}
                          value={values['PorcentajeComision']}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={touched['PorcentajeComision'] && Boolean(errors['PorcentajeComision'])}
                          helperText={touched['PorcentajeComision'] && errors['PorcentajeComision']}
                          disabled={isSubmitting || values?.Comisiona === false || values?.ComisionaPorImporte}
                        />
                      </Grid>

                      <Grid
                        item
                        md={12}
                        xs={12}
                        style={{
                          marginBottom: '1rem',
                          display: 'flex',
                          flexDirection: 'column',
                          flexGrow: 1,
                        }}>
                        <Typography color="textPrimary" gutterBottom variant="h3">
                          Texto pie presupuesto
                        </Typography>

                        <CKEditor
                          config={{
                            toolbar: {
                              items: ['bold', 'italic', '|', 'undo', 'redo', '-', 'numberedList', 'bulletedList'],

                              shouldNotGroupWhenFull: true,
                            },
                          }}
                          editor={ClassicEditor}
                          data={values.TextoPiePresupuesto}
                          onReady={editor => {
                            // You can store the "editor" and use when it is needed.
                          }}
                          onChange={(_, editor) => {
                            const data = editor.getData();
                            setFieldValue('TextoPiePresupuesto', data);
                          }}
                        />
                      </Grid>

                      <Grid
                        item
                        md={12}
                        xs={12}
                        style={{
                          marginBottom: '1rem',
                          display: 'flex',
                          flexDirection: 'column',
                          flexGrow: 1,
                        }}>
                        <Typography color="textPrimary" gutterBottom variant="h3">
                          Texto transferencias presupuesto
                        </Typography>
                        <CKEditor
                          config={{
                            toolbar: {
                              items: ['bold', 'italic', '|', 'undo', 'redo', '-', 'numberedList', 'bulletedList'],

                              shouldNotGroupWhenFull: true,
                            },
                          }}
                          editor={ClassicEditor}
                          data={values.TextoTransferencias}
                          onReady={editor => {
                            // You can store the "editor" and use when it is needed.
                          }}
                          onChange={(_, editor) => {
                            const data = editor.getData();
                            setFieldValue('TextoTransferencias', data);
                          }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
                <Box
                  sx={{
                    marginTop: '20px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    p: '2',
                  }}>
                  <Button
                    style={{
                      marginRight: '20px',
                      backgroundColor: '#F39868',
                      color: '#fff',
                      borderRadius: 7,
                      marginLeft: 10,
                    }}
                    onClick={() => navigate('/users')}>
                    <Typography style={{ fontWeight: 'bold' }}>Cancelar </Typography>
                  </Button>

                  <LoadingButton
                    variant="contained"
                    type="submit"
                    loading={isSubmitting}
                    disabled={!isValid}
                    style={{
                      backgroundColor: '#E5824F',
                    }}>
                    Actualizar
                  </LoadingButton>
                </Box>
              </Form>
            </Grid>
          );
        }}
      </Formik>
    </LocalizationProvider>
  );
};
